import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_ASSOCIATION } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetPropertyAssociationListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyAssociationList = async (data: any) =>
  await axiosAuth.post(`${PROPERTY_ASSOCIATION}/grid`, data);

const useGetPropertyAssociationList = ({
  data,
  queryParams,
}: UseGetPropertyAssociationListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => getPropertyAssociationList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyAssociationList;
